import { TextField } from '@gerdau/hefesto';
import React from 'react';

interface IIsManagerCustomerInputProps {
  title: string;
  customerId: string;
  setCustomerId(customerId: string): void;
  loading: boolean;
  bpError: boolean;
  customerName?: string;
}

const IsManagerCustomerInput: React.FC<IIsManagerCustomerInputProps> = ({
  title,
  customerId,
  setCustomerId,
  loading,
  bpError,
  customerName
}) => {
  return (
    <TextField
      label={title}
      name={title}
      value={customerId}
      onChange={(e) => setCustomerId(e.target.value)}
      disabled={loading}
      placeholder="Digite o BP"
      variant={bpError && !loading ? 'danger' : undefined}
      supportMessage={
        bpError && !loading ? 'BP não encontrado' : customerName || ''
      }
    />
  );
};

export default IsManagerCustomerInput;
